import { useNotificationsCount } from '../../../hooks/notifications';
import { getFormatNumberString } from '../../../../../helpers/getFormatNumberString';
import useSelector from '../../../../../infrastructure/useSelector';
import React, { ReactElement, useContext } from 'react';
import { WMSkeleton } from '@walkme/wm-ui';
import { AppTableContext } from '../../../../AppTable/AppTableContext';
import classes from '../../NotificationsTable.module.scss';
import _isNumber from 'lodash/isNumber';
import { useTranslation, Trans } from 'react-i18next';

const keyPrefix = 'components.notificationsList.notificationsTable.table-parts.notificationsTableNameTitle';

const NumberWithSkeleton = ({ count }: { count?: number | null }) => (
    <>
        {_isNumber(count) ? getFormatNumberString(count) : <WMSkeleton className={classes.countSkeleton} variant={'circle'} height={14} width={14} />}
    </>
);

const Title = ({ count }: { count?: number }) => {
    return (
        <Trans i18nKey={`${keyPrefix}.notificationTitle`} count={count}>
            <NumberWithSkeleton count={count} />
        </Trans>
    );
};

const OutOfNotificationsTitle = ({ count }: { count?: number }) => {
    const { t } = useTranslation('', { keyPrefix });
    const activeTab = useSelector(store => store.notifications.activeTab);
    const allNotificationsCount = useNotificationsCount(false);
    const amount = allNotificationsCount?.[activeTab];

    return (
        <Trans i18nKey={`${keyPrefix}.outOfNotificationsTitle`} count={count}>
            <NumberWithSkeleton count={count} />
            <span className={classes.myNotificationsOnlyTitle}>
                <NumberWithSkeleton count={amount} />
                {t('activeTabNotification', {
                    count: amount ?? 0,
                    activeTab
                })}
            </span>
        </Trans>
    );
};

const NotificationsTableNameTitle = ({ count, subtitle }: { count?: number; subtitle: string | ReactElement }) => {
    const { loading } = useContext(AppTableContext);
    const allNotificationsView = useSelector(store => store.notifications.allNotificationsView);

    const showOutofNotifications = allNotificationsView !== undefined && !allNotificationsView;

    return (
        <div className={classes.titleAndSubtitle}>
            {loading ? (
                <>
                    <WMSkeleton className={classes.titleSke} height={14} width={100} />
                    <WMSkeleton className={classes.subtitleSkeleton} height={12} width={200} />
                </>
            ) : (
                <>
                    <div className={classes.title}>
                        {!showOutofNotifications ? <Title count={count} /> : <OutOfNotificationsTitle count={count} />}
                    </div>
                    <div className={classes.subTitle}>{subtitle}</div>
                </>
            )}
        </div>
    );
};

export default NotificationsTableNameTitle;
